import { render, staticRenderFns } from "./BatchLogs.vue?vue&type=template&id=1459752b&"
import script from "./BatchLogs.js?vue&type=script&lang=js&"
export * from "./BatchLogs.js?vue&type=script&lang=js&"
import style0 from "./BatchLogs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports